<template>
  <v-list>
    <draggable 
      :list="projectListArray"
      :disabled="!enabled"
      :handle="'.mover'"
      class="list-group"
      ghost-class="ghost"
      :move="checkMove"
      @start="dragging = true"
      @end="onEnd"
      animation="100"
      :forceFallback="true"
    >
      <!-- @end="dragging = false" -->
      <!-- list-group-item -->
      <div
        :class="project.isCheck==true?itemisCheck:listgroupitem"
        v-for="(project, pIndex)  in projectListArray"
        :key="pIndex"
        @click.stop="checkProject(project._id)"
         :ondrop="false" :ondragover="false"
      >
        <i class="el-icon-notebook-2 mover" style="font-size: 14px;margin-right: 10px;"></i>
        <span class="projectText" >

          {{ projectName }} {{ pIndex + 1 }} .
          {{project.name}}
          <md-tooltip md-direction="top">{{project.name}}</md-tooltip>
        </span>
        <p class="btns" v-if="course.hasAuthModify"  >
          <v-btn 
            v-hasPermi="['dev::project::edit']"
            class="btnEdit"
            icon
            small
            @click="handleProjectChange('edit',project.name)"
          >
            <span class="material-icons" style="font-size:20px;">edit</span>
            <md-tooltip md-direction="top">编辑所选{{projectName}}</md-tooltip>
          </v-btn>

          <v-btn 
            v-hasPermi="['dev::project::remove']"
            class="btnProjectDel"
            icon
            small
            @click="handleProjectRemove(project.name,pIndex)"
          >
            <span class="material-icons" style="font-size:20px;  ">delete_forever</span>
            <md-tooltip md-direction="top">删除所选{{projectName}}</md-tooltip>
          </v-btn>
        </p>
      </div>
    </draggable>

    <!-- 
 <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
      <v-list-item
        v-for="(project, pIndex) in projectList"
        :key="`item` + pIndex"
        link
        :value="project._id"
        @click.stop="checkProject(project._id)"
      >
        <template v-slot:default="{ active }">
          <v-list-item-action style="margin-right: 10px">
            <v-checkbox :input-value="active" color="purple" size="mini"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              v-text="
                `${projectName}${project.orderNum}. ${
                  project.name.length > 10 ? project.name.substring(0, 10) + '...' : project.name
                }`
              "
            ></v-list-item-title>
            <md-tooltip md-direction="top">{{ projectName }} {{ pIndex + 1 }} . {{ project.name }}</md-tooltip>
          </v-list-item-content>

          <v-btn
            v-hasPermi="['dev::project::edit']"
            class="btnEdit"
            icon
            small
            @click.stop="handleProjectChange('edit')"
            v-show="active"
          >

            <span class="material-icons" style="font-size:20px;">edit</span>
            <md-tooltip md-direction="top">编辑所选{{projectName}}</md-tooltip>
          </v-btn>

          <v-btn
            v-show="active"
            v-hasPermi="['dev::project::remove']"
            class="btnProjectDel"
            icon
            small
            @click.stop="handleProjectRemove"
          >

            <span class="material-icons" style="font-size:20px;">delete_forever</span>
            <md-tooltip md-direction="top">删除所选{{projectName}}</md-tooltip>
          </v-btn>
        </template>
      </v-list-item>
    </v-list-item-group>-->
    <CourseInfo />
    <ProjectInfo />
    <SceneList />
  </v-list>
</template>
<script>
import draggable from 'vuedraggable';
import CourseInfo from './Action/CourseInfo.vue';
import ProjectInfo from './Action/ProjectInfo.vue';
import SceneList from './Action/SceneList.vue';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

import { updateProjectSort } from '@/api/course';

export default {
  data: () => ({
    enabled: true,
    list: [
      { name: '1 - John', id: 0 },
      { name: '2 - Joao', id: 1 },
      { name: '3 - Jean', id: 2 },
    ],
    dragging: false,

    course_id: '',
    course_info: {},
    project_id: '',
    projectMap: {},
    group: 0,
    preName: '章节',
    projectListArray: [],
    itemisCheck: 'list-group-itemisCheck',
    listgroupitem: 'list-group-item',
  }),
  computed: {
    ...mapGetters(['course', 'project','isMobile']),
    // projectList() {
    //   if(this.course.children){
    //         this.projectListArray = this.course.children
    //   }
    //    this.projectListArray.forEach((item)=>{item.isCheck = false})
    // },
    projectName() {
       let str = ''
      if (this.course.sectionType == 'xm') {
        str =  '项目';
      } else if (this.course.sectionType == 'zj') {
        str =  '章节';
      } else if (this.course.sectionType == 'qj') {
        str =  '情境';
      } else {
        str =  '章节';
      }
      return str;
    },
    // isShown() {
    //   // 你可以在这里定义你的逻辑，例如：
    //   // 如果路由参数中包含id，并且id的值是你期望的值，则显示元素
    //   const tab = this.$route.query.tab;
    //   if(tab=='0'){
    //      return false
    //   }
    //   return true; // 替换 'expectedValue' 为你期望的id值
    // }
    // preName() {
    //   return this.course.childType === 'chapter' ? '章节' : '项目'
    // },

  },
  watch: {
    course(val) {
      if (val.children.length > 0) {
        this.projectListArray = val.children;
        this.projectListArray.forEach(item => {
          this.$set(item, 'isCheck', false);
        });
        this.projectListArray[0].isCheck = true;
        //  this.projectListArray[this.projectListArray.length-1].isCheck = true
      }
    },
    project(val) {
      this.group = val._id;
      if (!this.group) {
        this.$emit('setBtndisabled', true);
        return;
      }
      this.$emit('setBtndisabled', false);
    },
  },
  components: {
    CourseInfo,
    ProjectInfo,
    SceneList,
    draggable,
  },
  created() {
    // this.$store.dispatch("courseAndProject/refreshCourseList");
  },
  mounted() {
    let _this = this;
    this.$EventBus.$on('selectCourse', function (data) {
      _this.$nextTick(() => {
        const project = _this.course.children.find(item => item._id === _this.project._id);
        _this.$store.dispatch('courseAndProject/initUpdateProject', Object.assign({}, project), {});
        _this.$store.dispatch('editor/closeEditor');
      });
    });
    // this.projectListArray[0].isCheck = true
  },
  destroyed() {
    this.$EventBus.$off('selectCourse');
  },
  methods: {

    async onEnd(data) {
      let arr = [];
      this.projectListArray.forEach((item, index) => {
        let obj = {
          _id: item._id,
          orderNum: index + 1,
        };
        arr.push(obj);
      });
      let params = {
        arr,
      };
      await updateProjectSort(params).then(res => {
        // console.log(res);
      });
    },
    checkMove: function (e) {
      // window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    async handleProjectRemove(name, index) {
      let result = await Swal.fire({
        title: '提示',
        text: `确认删除 ${this.projectName + (index + 1)}【${name}】?`,
        type: 'error',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch('courseAndProject/removeProject', this.callBackQueryProject);
      }
    },
    callBackQueryProject(data) {
      if (data) {
        this.checkProject(data._id);
      }
    },
    async handleCourseChange(status) {
      this.$store.dispatch('courseAndProject/reverseShowCourseEdit', status);
    },
    async handleProjectChange(status) {
      setTimeout(() => {
        this.$store.dispatch('courseAndProject/reverseShowProjectEdit', status);
      }, 100);
    },
    async checkCourse(course) {
      this.course_info = course;
      this.$store.dispatch('courseAndProject/updateCourse', Object.assign({}, course));
      this.project_id = '';
    },
    async checkProject(id) {
      this.project_id = id;
      const project = this.course.children.find(item => item._id === this.project_id);

      this.$EventBus.$emit('getpageSize', function (data) {
        if (data) {
          project.perPage = data.perPage;
          project.currentPage = data.currentPage;
        }
      });

      // this.$store.dispatch('courseAndProject/updateProject', Object.assign({}, project));
      this.$store.dispatch('courseAndProject/updateProjectData', Object.assign({}, project));
      this.$store.dispatch('editor/closeEditor');
      this.projectListArray.forEach(element => {
        if (id == element._id) {
          this.$set(element, 'isCheck', true);
        } else {
          this.$set(element, 'isCheck', false);
        }
      });
    },
  },
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  width: 100%;
  /* margin-left: 5px; */
}

.list-group .list-group-item {
  cursor: pointer;
  position: relative;
  display: block;
  padding: 5px 10px;
  margin-bottom: -1px;
  background-color: #fff;
  border-radius: 2px;
  margin: 5px 0;
}

.list-group-itemisCheck {
  cursor: pointer;
  position: relative;
  display: block;
  padding: 5px 10px;
  margin-bottom: -1px;
  background-color: #f3ecff;
  border-radius: 2px;
  margin: 5px 0;
}

.checkout {
  display: inline-block;
  margin: 0px;
  padding: 0px;
  height: 25px;
  vertical-align: middle;
}
.btns {
  float: right;
  overflow: hidden;
  margin: 0;
  width: 35%;
  text-align: center;
}

.btns button{
  width: 24px;
   
}

.sortable-chosen {
  /*border: 1px solid #4caf50 !important;*/
}

.projectText {
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  /* width: 65% !important; */
  vertical-align: middle;

 /*   overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
   width: 60% !important; */
}

</style>
